<template>
<div class="cateDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' :title="'编辑商品分类'" :visible.sync="dialogVisible" width="600px">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm form">
            <el-form-item label="标签名称" class="content" prop="catename">
                <div class="label">
                    <el-input v-model.trim="item.catename" placeholder="请输入分类名称，不超过8个字" maxlength="8" clearable></el-input>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {uploadEventProductCategoryInfo, uploadProviderEventProductCategoryInfo} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'cateDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                catecode: '',
                catename: ''
            },
            rules: {
                catename: [
                    {required: true, message: '请输入分类名称', trigger: 'blur'}
                ]
            },
            hostroletype: 2
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm('确认提交分类', '提示', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        if (this.hostroletype === 2 || this.hostroletype === '2') {
                            this._save()
                        } else {
                            this._save2()
                        }
                    })
                }
            })

        },
        openDialog(cate, hostroletype) {
            this.item.catecode = cate.catecode
            this.item.catename = cate.catename
            this.hostroletype = hostroletype
            this.dialogVisible = true
        },
        _save() {
            this.setLoading(true)
            uploadEventProductCategoryInfo({
                data: Object.assign({}, this.item),
                success: data => {
                    this.$message.success('编辑成功')
                    this.$emit('getEventProductCategoryList')
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _save2() {
            this.setLoading(true)
            uploadProviderEventProductCategoryInfo({
                data: Object.assign({}, this.item),
                success: data => {
                    this.$message.success('编辑成功')
                    this.$emit('getEventProductCategoryList2')
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user', 'params', 'brandBusiness'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.cateDialog {
}
</style>
